import React from "react";
import cn from "classnames";
import * as styles from "./HeaderMenuItem.module.scss";

function HeaderMenuItem({isNew, name, children, href, onClick, mobileView}) {
  const MenuItemLink = href ? "a" : "span";

  return (
    <div
      className={cn(
        styles.root,
        mobileView === "show" && styles.mobileShow,
        mobileView === "hidden" && styles.mobileHidden,
        mobileView === "expand" && styles.mobileExpand
      )}
    >
      <MenuItemLink
        className={cn(styles.menuLink, isNew && styles.newDot, onClick && styles.buttonLink)}
        href={href}
        onClick={onClick}
      >
        {name}
      </MenuItemLink>

      {children && !onClick ? (
        <div
          className={cn(
            styles.expandMenu,
            name === "Platform" && styles.platformMenu,
            name === "Support" && styles.supportMenu
          )}
        >
          {children}
        </div>
      ) : null}
    </div>
  );
}
export default HeaderMenuItem;
